// Centralised API config. Every axios call uses `withCredentials: true` so the
// httpOnly session cookie travels cross-origin between the preview frontend
// and the FastAPI backend.

import axios from "axios";

axios.defaults.withCredentials = true;

// When the server signals an expired session, jump straight back to /login.
// We avoid an infinite loop by only redirecting once per session and never on
// the login endpoint itself.
let _onUnauthenticated = null;
export const setUnauthenticatedHandler = (fn) => { _onUnauthenticated = fn; };

axios.interceptors.response.use(
    (resp) => resp,
    (err) => {
        const url = err?.config?.url || "";
        if (err?.response?.status === 401 && !url.endsWith("/api/auth/login") && !url.endsWith("/api/auth/me")) {
            try { _onUnauthenticated && _onUnauthenticated(); } catch { /* ignore */ }
        }
        return Promise.reject(err);
    }
);

export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

/** Wraps axios.get and surfaces a stable error shape with `status`. */
export const apiGet = async (url, config = {}) => {
    try {
        const r = await axios.get(url, { withCredentials: true, ...config });
        return { data: r.data, status: r.status, error: null };
    } catch (e) {
        const status = e?.response?.status || 0;
        const detail = e?.response?.data?.detail || e?.message || "request failed";
        return { data: null, status, error: detail };
    }
};

export const apiPost = async (url, body = undefined, config = {}) => {
    try {
        const r = await axios.post(url, body, { withCredentials: true, ...config });
        return { data: r.data, status: r.status, error: null };
    } catch (e) {
        const status = e?.response?.status || 0;
        const detail = e?.response?.data?.detail || e?.message || "request failed";
        return { data: null, status, error: detail };
    }
};
